<template>
  <div class="d-block d-md-none mt-auto mx-auto mb-3" style="max-width: 400px">
    <div class="mx-auto mb-4 text-center">
      <a
        v-for="srvc in showingServices"
        :key="srvc.name"
        :href="
          `${srvc.url}/?utm_source=accounts&utm_medium=logo&utm_term=${srvc.name}&utm_campaign=${utmCampaign}`
        "
        class="d-inline-block mx-2"
        target="_blank"
        style="height: 45px"
        :data-gtm-name="
          utmCampaign === 'login'
            ? 'login_service_links'
            : 'logout_service_link'
        "
        :data-gtm-value-one="srvc.name"
        :data-gtm-value-two="
          `${srvc.url}/?utm_source=accounts&utm_medium=logo&utm_term=${srvc.name}&utm_campaign=${utmCampaign}`
        "
      >
        <!-- :style="srvc.name === 'jaryan' ? {width: '70px'} : {width: '45px'}" -->
        <img
          class="d-block h-100"
          :src="platformLogos[srvc.name]"
          :alt="`${srvc.name} logo`"
        />
      </a>
    </div>
    <div
      :class="['mx-auto text-center', { rtl: $i18n.locale === 'fa' }]"
      style="font-size: 13px; color: #666; margin-top: 10px;line-height: 2;"
    >
      {{ $t("service_promotion_slogan.long") }}
    </div>
  </div>
</template>

<script>
import services from "./serviceList.js";

export default {
  data: () => ({ platformLogos }),
  props: {
    utmCampaign: {
      type: String,
      required: true,
    },
    pltService: {
      type: String,
      default: "",
    },
  },
  computed: {
    showingServices() {
      return this.services.filter(({ name }) => name !== this.pltService);
    },
  },
  created() {
    this.services = services("mobile");
  },
};
</script>

<style></style>
